var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("投标")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "right",
              on: {
                click: function($event) {
                  _vm.$router.back(-1)
                }
              }
            },
            [_vm._m(0)]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { ref: "bidDoc", attrs: { model: _vm.bidDoc, rules: _vm.rules } },
        [
          _c(
            "div",
            { staticClass: "bid-container" },
            [
              _c("div", { staticClass: "content-caption dashed bg-white" }, [
                _c("span", [_vm._v("招标信息")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }, [
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("招标标题")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.title))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("报名时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.publishTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("报名截止时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.openTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("投标时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.openTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("投标截止时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.closeTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("公布结果时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.resultPublishTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("招标预算")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm.callBidDocInfo.budgetFlag == 0
                      ? _c("label", { staticClass: "mr20" }, [_vm._v("无预算")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.callBidDocInfo.budgetFlag == 2
                      ? _c("label", { staticClass: "mr20" }, [
                          _vm._v(
                            "固定总额 " +
                              _vm._s(_vm.callBidDocInfo.budgetAmount) +
                              " 元"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("要求注册资金")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.reqRegCapital) + " 万元")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }, [
                _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("投标信息")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-single col-2",
                    staticStyle: { overflow: "visible" }
                  },
                  [
                    _c("div", { staticClass: "title required" }, [
                      _vm._v("投标报价")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "offerPrice" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                placeholder: "请输入报价金额",
                                type: "number"
                              },
                              model: {
                                value: _vm.bidDoc.offerPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.bidDoc,
                                    "offerPrice",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "bidDoc.offerPrice"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("(元)")])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-single col-2",
                    staticStyle: { overflow: "visible" }
                  },
                  [
                    _c("div", { staticClass: "title required" }, [
                      _vm._v("联系人")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "contactName" } },
                          [
                            _c("el-input", {
                              staticClass: "width-1-5x",
                              attrs: { placeholder: "请输入联系人" },
                              model: {
                                value: _vm.bidDoc.contactName,
                                callback: function($$v) {
                                  _vm.$set(_vm.bidDoc, "contactName", $$v)
                                },
                                expression: "bidDoc.contactName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-single col-2",
                    staticStyle: { overflow: "visible" }
                  },
                  [
                    _c("div", { staticClass: "title required" }, [
                      _vm._v("联系电话")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "contactTel" } },
                          [
                            _c("el-input", {
                              staticClass: "width-1-5x",
                              attrs: { placeholder: "请输入联系方式" },
                              model: {
                                value: _vm.bidDoc.contactTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.bidDoc, "contactTel", $$v)
                                },
                                expression: "bidDoc.contactTel"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-single col-2" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("邮箱")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactEmail" } },
                        [
                          _c("el-input", {
                            staticClass: "width-1-5x",
                            attrs: { placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.bidDoc.contactEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.bidDoc, "contactEmail", $$v)
                              },
                              expression: "bidDoc.contactEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.bidGoodsList != null && _vm.bidGoodsList.length > 0
                ? _c(
                    "div",
                    { staticClass: "content-caption dashed bg-white" },
                    [_c("span", [_vm._v("商品信息")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bidGoodsList != null && _vm.bidGoodsList.length > 0
                ? _c("div", [
                    _c("table", { staticClass: "custom-tbl" }, [
                      _c("thead", { staticClass: "head" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "200" }
                            },
                            [
                              _c("span", { staticClass: "ml5" }, [
                                _vm._v("招标产品")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("招标数量")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("招标单位")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "ml5" }, [
                              _vm._v("投标产品")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("招标质保期(月)")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("投标质保期(月)")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "100" } }, [
                            _vm._v("投标价格(元)")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "60" } }, [_vm._v("操作")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "body" },
                        _vm._l(_vm.bidGoodsList, function(bidGoods) {
                          return _c("tr", { staticClass: "row" }, [
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", { staticClass: "ml5" }, [
                                  _vm._v(_vm._s(bidGoods.callName))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(bidGoods.callQuantity))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(bidGoods.callUnit))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", { staticClass: "ml5" }, [
                                  _vm._v(_vm._s(bidGoods.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(bidGoods.callWrntPeriod))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  model: {
                                    value: bidGoods.wrntPeriod,
                                    callback: function($$v) {
                                      _vm.$set(bidGoods, "wrntPeriod", $$v)
                                    },
                                    expression: "bidGoods.wrntPeriod"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  model: {
                                    value: bidGoods.price,
                                    callback: function($$v) {
                                      _vm.$set(bidGoods, "price", $$v)
                                    },
                                    expression: "bidGoods.price"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.showMerchantGoodsDialog(
                                        bidGoods.callId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("选择")]
                              )
                            ])
                          ])
                        })
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-caption dashed bg-white mt30" },
                [_c("span", [_vm._v("服务信息")])]
              ),
              _vm._v(" "),
              _vm.bidServcList != null && _vm.bidServcList.length > 0
                ? _c("div", [
                    _c("table", { staticClass: "custom-tbl" }, [
                      _c("thead", { staticClass: "head" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "300" }
                            },
                            [
                              _c("span", { staticClass: "ml5" }, [
                                _vm._v("招标服务")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "text-align": "left" } }, [
                            _c("span", { staticClass: "ml5" }, [
                              _vm._v("投标服务")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "100" } }, [
                            _vm._v("投标价格")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "60" } }, [_vm._v("操作")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "body" },
                        _vm._l(_vm.bidServcList, function(bidServc) {
                          return _c("tr", { staticClass: "row" }, [
                            _c(
                              "td",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "300" }
                              },
                              [
                                _c("span", { staticClass: "ml5" }, [
                                  _vm._v(_vm._s(bidServc.callName))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", { staticClass: "ml5" }, [
                                  _vm._v(_vm._s(bidServc.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  model: {
                                    value: bidServc.price,
                                    callback: function($$v) {
                                      _vm.$set(bidServc, "price", $$v)
                                    },
                                    expression: "bidServc.price"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.showMerchantServcDialog(
                                        bidServc.callId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("选择")]
                              )
                            ])
                          ])
                        })
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "content-caption dashed bg-white" }, [
                _c("span", [_vm._v("附件信息")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-single mt20" }, [
                _c("div", { staticClass: "title required" }, [
                  _vm._v("上传附件")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content required",
                    staticStyle: { "padding-left": "38px" }
                  },
                  [
                    _c("swb-file-upload", {
                      attrs: {
                        fileFor: "solution",
                        fileGroup: "image-goods",
                        onBeforeUpload: _vm.onBeforeUpload,
                        onProgress: _vm.onProgress,
                        onDone: _vm.onUploadDone,
                        multipleFile: true
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "file-area clearfix" },
                      _vm._l(_vm.bidFileList, function(bidFile, index) {
                        return _c("swb-file-item", {
                          attrs: {
                            trackKey: index,
                            editable: true,
                            tag: bidFile.tag,
                            fileName: bidFile.name,
                            fileUuid: bidFile.fileUuid,
                            fileBrowseUrl: bidFile.fileBrowseUrl,
                            fileDownloadUrl: bidFile.fileDownloadUrl,
                            fileMd5: bidFile.fileMd5,
                            deletable: true,
                            onDelete: _vm.removeUpload,
                            onUploaded: _vm.echoUploadedFileInfo
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-caption dashed bg-white" }, [
                _c("span", [_vm._v("商务条款")])
              ]),
              _vm._v(" "),
              _vm.bidTermParams.tradeRuleList != null
                ? _c("swb-create-trade-rule", {
                    ref: "swb_create_trade_rule",
                    attrs: {
                      comparedTradeRuleList: _vm.bidTermParams.tradeRuleList,
                      forBid: true,
                      forGoods: _vm.bidTermParams.forGoods,
                      operate: _vm.bidTermParams.operate,
                      forServc: _vm.bidTermParams.forServc,
                      type: _vm.bidTermParams.type,
                      returnType: _vm.bidTermParams.returnType
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-toolbar align-center mt30",
          staticStyle: { padding: "0" }
        },
        [
          _c(
            "button",
            {
              staticClass: "swb-btn mr20",
              on: {
                click: function($event) {
                  _vm.saveBidDoc()
                }
              }
            },
            [_vm._v("保存")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24293f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24293f92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/SaveBidDoc.vue
// module id = 2123
// module chunks = 1